import { useSelector } from 'react-redux';
import AppLayout from '../components/global/layout/Layout.jsx';
import { Navigate, useParams } from 'react-router-dom';

const ProtectedRoute = ({ type, children, ib, title, parent }) => {

    const { loggedIn } = useSelector(state => state.user);
    const { userDetails } = useSelector(state => state.user);
    const params = useParams();
    let mainParent = parent
    if (parent) {
        mainParent = parent.map(item => ({ ...item, path: item.path.replace(':id', params.id) }))
    }
    if (type === "private") {
        if (loggedIn) {
            // if (userDetails?.kycStatus === 'Approved') {
                if (ib == 'parent') { return children }
                if (ib == 'ib') { return <AppLayout ib={true} title={title} parent={mainParent}>{children}</AppLayout> }
                return <AppLayout ib={false} title={title} parent={mainParent}> {children} </AppLayout>
            // } else {
            //     return <Navigate to="/kyc" replace />
            // }
        } else {
            return <Navigate to="/" replace />
        }
    }
    if (type === "kyc") {
        if (loggedIn) {
            // return children
            return <AppLayout ib={false} title={title} parent={mainParent}>{children}</AppLayout>
        } else {
            return <Navigate to="/" replace />
        }
    }
    if (type === "public") {
        return children;
    }
    if (type === "auth") {
        if (!loggedIn) {
            return children;
        } else {
            return <Navigate to="/dashboard" replace />;
        }
    }
    return;
}

export default ProtectedRoute;